import React from "react";
import {
    Websites,
} from "../components";
import '../index.scss';

function WebsitesPage() {
    return (
        <Websites/>
    );
}

export default WebsitesPage;
